export const GET_DISPENSARY_DETAILS_REQUEST = 'GET_DISPENSARY_DETAILS_REQUEST'
export const GET_DISPENSARY_DETAILS_RESPONSE = 'GET_DISPENSARY_DETAILS_RESPONSE'
export const SET_DISPENSARY_DETAILS = 'SET_DISPENSARY_DETAILS'

export const GET_DOCTOR_LIST_REQUEST = 'GET_DOCTOR_LIST_REQUEST'
export const SET_DOCTOR_LIST = 'SET_DOCTOR_LIST'

export const GET_STAFF_REQUEST = 'GET_STAFF_REQUEST'
export const SET_STAFF = 'SET_STAFF'
